// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, useMediaQuery } from '@mui/material';

// project imports
import useConfig from 'hooks/useConfig';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { LayoutType } from 'utils/constants';
import LogoSection from './LogoSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import { openDrawer } from 'features/app/appSlice';

// assets
import { IconMenu2 } from '@tabler/icons';
import { selectShowMenu } from 'features/eai/selectors';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();

  const dispatch = useAppDispatch();
  const { drawerOpen, onChangeDrawerOpen } = useConfig();
  const showMenu = useAppSelector(selectShowMenu);

  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const { layout } = useConfig();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box
          component='span'
          sx={{
            display: { xs: 'none', md: 'block' },
            flexGrow: 1,
            width: '214px'
          }}
        >
          <LogoSection />
        </Box>
        {showMenu &&
          (layout === LayoutType.VERTICAL_LAYOUT ||
            (layout === LayoutType.HORIZONTAL_LAYOUT && matchDownMd)) && (
            <Avatar
              variant='rounded'
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                overflow: 'hidden',
                transition: 'all .2s ease-in-out',
                background:
                  theme.palette.mode === 'dark'
                    ? theme.palette.dark.main
                    : theme.palette.secondary.light,
                color:
                  theme.palette.mode === 'dark'
                    ? theme.palette.secondary.main
                    : theme.palette.secondary.dark,
                '&:hover': {
                  background:
                    theme.palette.mode === 'dark'
                      ? theme.palette.secondary.main
                      : theme.palette.secondary.dark,
                  color:
                    theme.palette.mode === 'dark'
                      ? theme.palette.secondary.light
                      : theme.palette.secondary.light
                }
              }}
              onClick={() => {
                dispatch(openDrawer(!drawerOpen));
                onChangeDrawerOpen(!drawerOpen);
              }}
              color='inherit'
            >
              <IconMenu2 stroke={1.5} size='20px' />
            </Avatar>
          )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexFlow: 'row-nowrap',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            mr: 3,
            [theme.breakpoints.down('md')]: {
              mr: 2
            }
          }}
        >
          <LocalizationSection />
        </Box>

        <ProfileSection />

        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <MobileSection />
        </Box>
      </Box>
    </>
  );
};

export default Header;
